// src/esa/esa.js
import { VehicleManager } from '../vehicleManager.js';

let v, v2; //VehicleManager instantiated in load page
let vehicleIsChanged = [null, false, false]; // vehicle 1,2 as index

const startingVehicles = {
   v1: { group: 0, type: 0 },
   v2: { group: 1, type: 5 },
};

$(function () {
   try {
      v = new VehicleManager('wa-trucks');
      v2 = new VehicleManager('wa-trucks');
      $('.tare-input').prop('disabled', true);

      initHandlers();
      loadPage(); // get the vehicles database and refresh the page.
   } catch (error) {
      console.error(error.message);
      window.location.href =
         '/error?message=' + encodeURIComponent('An unexpected error occurred on starting the esa tool.');
   }
});

function loadPage() {
   // Populate vehicle types dropdowns
   const groups = v.getVehicleGroups();
   $('.vehicle-group').empty();
   for (let i = 0; i < groups.length; i++) {
      const name = groups[i].name;
      const val = groups[i].index;
      $('#vehicle-group-1').append(new Option(name, val));
      $('#vehicle-group-2').append(new Option(name, val));
   }

   // retrieve available vehicles and then populate page
   const customEntries = [];
   v.initVehicles(customEntries, function () {
      resetFormValues(1, startingVehicles.v1.group, startingVehicles.v1.type);
      updateDefaultLoads(1);
   });
   v2.initVehicles(customEntries, function () {
      resetFormValues(2, startingVehicles.v2.group, startingVehicles.v2.type);
      updateDefaultLoads(2);
   });
}

function initHandlers() {
   // handle vehicle group changing
   $('.vehicle-group').on('change', function () {
      let id = this.getAttribute('id'); // get the id, e.g., "vehicle-group-1"
      let vehicleNumber = parseInt(id.split('-').pop()); // split by '-' and take the last part, and parse it to an integer
      selectVehicleGroup(vehicleNumber, this.value); // also sets default vehicle group
      updateDefaultLoads(vehicleNumber); // when vehicle changes default loads change also
   });

   $('.vehicle-type').on('change', function () {
      let id = this.getAttribute('id');
      let vehicleNumber = parseInt(id.split('-').pop());
      selectVehicleType(vehicleNumber, this.value);
      updateDefaultLoads(vehicleNumber); // when vehicle changes default loads change also
   });

   // details button
   $('.detailsButton').on('click', function () {
      // Change text in details button depending on show/hide
      var $this = $(this);
      $this.toggleClass('detailsButtonShown');

      if ($this.hasClass('detailsButtonShown')) {
         $this.text('Hide Details');
      } else {
         $this.text('Show Details');
      }
   });

   // AXLES - handle change number axles
   $('.axles-wrapper').on('click', '.axle-option', function () {
      // Get the parent of the clicked axle option - axle-group-axles
      var $parent = $(this).parent();

      // Remove 'selected' class from all axle options in the same parent
      $parent.children('.axle-option').removeClass('selected');

      // Get index of clicked axle option
      var clickedIndex = $(this).index();

      // Add 'selected' class to clicked axle option and all before it in the same parent
      $parent.children('.axle-option').each(function (index) {
         if (index <= clickedIndex) {
            $(this).addClass('selected');
         }
      });
      CalculateVehicle(getActiveVehicleNumber());
   });

   // WHEELS/TYRES - handle change events for width, tyres single/dual, loads
   $(document).on('change', '.width-select, .wheel-radio, .number-input', function () {
      CalculateVehicle(getActiveVehicleNumber());
   });

   // user changes payload value
   $(document).on('change', '.payload-input', function () {
      const vehicleNumber = getActiveVehicleNumber();
      const payload = getPayload(vehicleNumber);
      updateTare(vehicleNumber, payload); // we update the tare based on payload
      CalculateVehicle(vehicleNumber);
   });

   // Handle clicks on max load text
   // $(document).on('click', '.max-load-info', function (event) {
   //    // set the load to current maximum for this axle group.
   //    event.preventDefault();
   //    var groupNumber = this.id.split('-')[2];
   //    const maxLoadTxt = getMaxLoadTxt(this);

   //    const num = parseInt(groupNumber);
   //    const inputID = 'load-' + num;
   //    $(`#${inputID}`).val(maxLoadTxt);
   //    userChangedVehicle = true;
   //    CalculateVehicle();
   // });

   // copy table to clipboard support
   $('.copyButton').on('click', function () {
      const vehicleNumber = getActiveVehicleNumber();
      let $table = $(`#detailedGroupResultsTable-${vehicleNumber}`);
      let $temp = $('<textarea>');
      $('body').append($temp);
      $temp.val($table[0].outerHTML).select();

      if (!navigator.clipboard) {
         try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
         } catch (err) {
            console.error('Could not copy text: ', err);
         }
      } else {
         navigator.clipboard.writeText($temp.val()).then(
            function () {
               alert('Table copied to clipboard');
            },
            function (err) {
               console.error('Could not copy text: ', err);
            }
         );
      }
      $temp.remove();
   });

   // advnced mode switches
   $('.adv-sw').on('change', function () {
      var id = $(this).attr('id');
      let vehicleNumber = parseInt(id.split('-').pop());
      let divId = `#axles-div-${vehicleNumber}`;

      if ($(this).is(':checked')) {
         $(divId).slideDown();
      } else {
         $(divId).slideUp();
      }
   });
}

function resetFormValues(vehicleNumber, groupIndex, vehicleIndex) {
   //(vehicleNumber, defaultPayload);
   $(`#vehicle-group-${vehicleNumber}`).val(groupIndex);
   selectVehicleGroup(vehicleNumber, groupIndex, vehicleIndex);

   vehicleIsChanged[vehicleNumber] = false;

   // hide axles by default
   $(`#adv-sw-${vehicleNumber}`).prop('checked', false);
   $(`#axles-div-${vehicleNumber}`).hide();
}

function CalculateVehicle(vehicleNumber) {
   // Get all of the axle group selections, update page info
   var selections = getAxleGroupSelections(vehicleNumber); // get axle info and current gcm
   calcEsa(vehicleNumber, selections);
}

function getAxleGroupSelections(vehicleNumber) {
   var selections = [];
   let totalAxles = 0;
   let currentCombinedLoad = 0;

   // For each axle group within the parent axles-wrapper
   const id = '#axles-wrapper-' + vehicleNumber + ' .axle-group';
   $(id).each(function () {
      var group = getAxleGroupData(vehicleNumber, this);
      totalAxles += parseInt(group.axles);
      currentCombinedLoad += parseFloat(group.load);

      updateAxleGroupInfo(vehicleNumber, this); // update the title in the group at same time
      selections.push(group);
   });
   $(`#info-axles-${vehicleNumber}`).text(totalAxles); // update number of axles
   setGCM(vehicleNumber, currentCombinedLoad); // update to latest GCM
   return selections;
}

function getTotalLoad(vehicleNumber) {
   // iterate axle groups and get the sum of all axle group loads
   let totalLoad = 0;

   // For each axle group within the parent axles-wrapper
   const id = '#axles-wrapper-' + vehicleNumber + ' .axle-group';
   $(id).each(function () {
      var group = getAxleGroupData(vehicleNumber, this);
      totalLoad += parseFloat(group.load);
   });
   return totalLoad;
}

//
// Vehicles and types
//

function selectVehicleGroup(vehicleNumber, groupIndex, vehicleIndex = 0) {
   const vmanager = vehicleNumber == 1 ? v : v2;
   $(`#vehicle-group-${vehicleNumber}`).val(groupIndex);
   vmanager.setVehicleGroup(groupIndex);
   //const vehicles = vmanager.getActiveGroupVehicles();
   const names = vmanager.getActiveGroupVehicleNames();

   $(`#vehicle-type-${vehicleNumber}`).empty();
   for (let i = 0; i < names.length; i++) {
      $(`#vehicle-type-${vehicleNumber}`).append(new Option(names[i], i));
   }

   $(`#vehicle-type-${vehicleNumber}`).val(vehicleIndex);
   selectVehicleType(vehicleNumber, vehicleIndex); //default first entry =0
}

function selectVehicleType(vehicleNumber, vehicleIndex) {
   // Called when user changes vehicle type, removes and builds new axle groups
   const vmanager = vehicleNumber == 1 ? v : v2;
   vmanager.setActiveVehicle(vehicleIndex);
   const selectedVehicle = vmanager.getActiveVehicle();
   const path = vmanager.getImagePath();

   $(`#vehicleImage-${vehicleNumber}`).attr('src', path + selectedVehicle.image);
   updateVehicleInfo(vehicleNumber, selectedVehicle);
   buildAxleGroups(vehicleNumber, selectedVehicle);
}

function updateVehicleInfo(vehicleNumber, selectedVehicle) {
   // Update vehicle pane info when vehicle is changed.
   $(`#info-vehicle-${vehicleNumber}`).text(`${selectedVehicle.description}`);
   $(`#info-network-${vehicleNumber}`).text(selectedVehicle.approved + ' - ' + selectedVehicle.network);
   $(`#info-mass-${vehicleNumber}`).text(selectedVehicle.mass);
   $(`#info-length-${vehicleNumber}`).text(selectedVehicle.length);
}

//
// Vehicle axle groups
//

function buildAxleGroups(vehicleNumber, selectedVehicle) {
   // Called every time a new vehicle is selected.
   const numAxlesGroups = selectedVehicle.axle_groups;
   const parentDiv = $('#axles-wrapper-' + vehicleNumber);
   parentDiv.empty(); // remove all existing axle groups.

   // Append and stack new columns
   for (let i = 0; i < numAxlesGroups; i++) {
      const n = i + 1;
      const axleGroupHtml = buildAxleGroupCol(vehicleNumber, n, selectedVehicle);
      parentDiv.append(axleGroupHtml);
   }
}

function buildAxleGroupCol(vehicleNumber, num, selectedVehicle) {
   // This version is called when a new vehicle is selected and the axle group columns are built based on the defaults.
   // num is the axle group label 1. etc, num-1 is index in axles[]

   const minAxles = selectedVehicle.axles[num - 1].min;
   const maxAxles = selectedVehicle.axles[num - 1].max;
   const defaultAxles = num == 1 ? minAxles : maxAxles; // assumes min axles in steer group, max for the rest
   const defaultTyres = num == 1 ? 1 : 2; // except for first group, default is 2 tyres

   const axleOptions = buildAxleHtml(vehicleNumber, num, minAxles, maxAxles, defaultAxles);
   const wheelOptions = buildWheelHtml(vehicleNumber, num, defaultAxles, defaultTyres);
   const widthOptions = buildWidthHtml(vehicleNumber, num, defaultAxles, defaultTyres);
   const loadOptions = buildLoadHtml(vehicleNumber, num, defaultAxles, defaultTyres);

   const groupLabelContent = `${num}. ${getAxleGroupName(num, defaultAxles)}`;
   const infoContent = `${getAxleTypeName(num, defaultAxles)}, ${getTyresName(defaultTyres)}`;
   const groupInfo = `<div class="group-info">${infoContent}</div>`;

   return `
   <div class="col-5 col-md-3 col-lg-2 m-1 form-border axle-group">
      <div class = axle-group-head >
         <label for="axle-group-${num}" class="form-label">${groupLabelContent}</label>
      </div>
      <div class = axle-group-body >
         ${groupInfo}
         ${axleOptions}
         ${wheelOptions}
         ${widthOptions}
         ${loadOptions}
      </div>
   </div>`;
}

function updateAxleGroupInfo(vehicleNumber, groupElement) {
   // Updates the axle group lables and other elements.
   const d = getAxleGroupData(vehicleNumber, groupElement);
   const num = d.groupNumber;

   // The top label (axle group title) changes based on selections
   var groupLabelElement = $(groupElement).find('label:first');
   const groupLabelContent = `${num}. ${getAxleGroupName(num, d.axles)}`;
   groupLabelElement.text(groupLabelContent);

   // Group info - like 'Tandem axle, single tyres' (sub title)
   var groupInfoElement = $(groupElement).find('.group-info:first');
   const infoContent = `${getAxleTypeName(num, d.axles)}, ${getTyresName(d.tyres)}`;
   groupInfoElement.html(infoContent);

   // Tyre/Wheel options change based on the current axles selection.  The select control html is replaced.
   var wheelElement = $(groupElement).find('.btn-group:first');
   const wheelHtml = buildWheelHtml(vehicleNumber, num, d.axles, d.tyres);
   wheelElement.replaceWith(wheelHtml);

   // Width only visible when single tyres selected
   var widthElement = $(`#width-group${vehicleNumber}-` + num);
   if (d.tyres == 1) widthElement.show();
   else widthElement.hide();
}

function getAxleGroupData(vehicleNumber, groupElement) {
   var group = {};

   // Get the axle group number
   var groupNumber = $(groupElement).find('.form-label').attr('for').split('-')[2];
   group.groupNumber = parseInt(groupNumber);

   // Get the last selected axle-option
   const axleOption = $(groupElement).find('.axle-option.selected:last').attr('id').split('-')[2];
   group.axles = parseInt(axleOption);

   // Get the selected wheel-radio
   const tyreOption = $(groupElement).find('.wheel-radio:checked').attr('id').split('-')[2];
   group.tyres = parseInt(tyreOption);

   // Get the load
   group.load = $(groupElement).find('.number-input').val();

   // Get the max load
   group.maxLoad = $(groupElement).find('.form-control:disabled').val();

   // Get the selected width option
   const widthOption = $(`#width-select${vehicleNumber}-${groupNumber}`).val();
   const width = parseInt(widthOption);

   // width will be ignored when not single tyres
   group.width = group.tyres == 1 ? width : 0;

   return group;
}

function getAxleGroupName(i, axles) {
   let txt;
   switch (i) {
      case 1:
         txt = 'Steer group';
         break;
      case 2:
         if (axles == 3) txt = 'Tridrive group';
         else if (axles == 2) txt = 'Tandem drive group';
         else txt = 'Drive axle';
         break;
      default:
         txt = axles == 1 ? 'Trailer axle' : 'Trailer group';
         break;
   }
   return txt;
}

//
//  Axle types and options
//

function buildAxleHtml(vehicleNumber, num, axleMin, axleMax, axlesSelected) {
   // html for the wheel icons
   const iconClassAxle = 'fa-duotone fa-overline';

   // Set axle styling based on vehicle and axle number
   let optionsHTML = '';
   for (let i = 1; i <= axleMax; i++) {
      const disabledTag = i < axleMin || i > axleMax ? 'disabled' : '';
      const selectedTag = i <= axlesSelected ? 'selected' : '';
      optionsHTML += `
           <div class="axle-option ${selectedTag} ${disabledTag}" id="axle${vehicleNumber}-${num}-${i}"
           title="Select ${getAxleTypeName(num, i)}"><i class="${iconClassAxle}"></i></div>
       `;
   }

   return `
       <div id="" class="d-flex axle-group-axles m-1">
           ${optionsHTML}
       </div>`;
}

function getAxleTypeName(num, numAxles) {
   switch (numAxles) {
      case 1:
         return 'Single axle';
      case 2:
         return num > 1 ? 'Tandem axle' : 'Twinsteer';
      case 3:
         return 'Tri axle';
      case 4:
         return 'Quad axle';
      default:
         return '';
   }
}

//
//  Wheel/tyre types and options
//

function buildWheelHtml(vehicleNumber, num, axles, tyres) {
   // Note that the html is replaced each refresh and passed current axles

   // Disable the "Single" option and default to "Dual" when more than one axle
   let isSingleDisabled = '';
   let isDualDisabled = num == 1 ? 'disabled' : ''; // dual tyres not available for steer group
   let isSingleChecked = tyres == 1 ? 'checked' : '';
   let isDualChecked = !isSingleChecked ? 'checked' : '';
   let html = `
       <div class="btn-group btn-group-sm m-1" role="group">
           <input type="radio" class="btn-check wheel-radio" name="wheel-radio${vehicleNumber}-${num}" id="wheel${vehicleNumber}-${num}-1" ${isSingleDisabled} ${isSingleChecked}>
           <label class="btn btn-outline-secondary form-text-sm" for="wheel${vehicleNumber}-${num}-1" title="Select for single tyres per axle">Single</label>
           <input type="radio" class="btn-check wheel-radio" name="wheel-radio${vehicleNumber}-${num}" id="wheel${vehicleNumber}-${num}-2" ${isDualDisabled} ${isDualChecked}>
           <label class="btn btn-outline-secondary form-text-sm" for="wheel${vehicleNumber}-${num}-2" title="Select for dual tyres per axle">Dual</label>
       </div>`;

   return html;
}

function buildWidthHtml(vehicleNumber, num, axles, tyres) {
   let html = `
   <div class="input-group input-group-sm m-1" id="width-group${vehicleNumber}-${num}">
      <label for="width-select${vehicleNumber}-${num}" class="input-group-text form-text-sm" >Tyre&nbsp</label>
      <select class="form-select form-text-sm width-select" id="width-select${vehicleNumber}-${num}" name="width-select-${num}">
         <option value="0" selected>&lt;375mm</option>
         <option value="1">375-450mm</option>
         <option value="2">&gt;450mm</option>
      </select>
   </div>`;

   return html;
}

function getTyresName(i) {
   switch (i) {
      case 1:
         return 'single tyres';
      case 2:
         return 'dual tyres';
      default:
         return '';
   }
}

//
//  Axle Load and options
//

function buildLoadHtml(vehicleNumber, num, axles, tyres) {
   // called during building a load group column.
   // default load is the max load.
   //const load = getMaxLoad(axles, tyres);
   const load = num == 1 ? 7.1 : '10'; // single steer axle default is 7.1t (this are overwritten when then is a max load received)

   const iconHtml = `<i class="fa-solid fa-triangle-exclamation max-load-icon" id="max-load-icon${vehicleNumber}-${num}" title="Warning - Current load may exceed maximum allowed" style="display: none;"></i>`;
   const badgeHtml = `
   <a href="#" class="badge-hover">
      <span class='badge rounded-pill bg-secondary max-load-value' title="Use the maximum load as the load"> </span>
   </a>
   `;
   const html = `
   <div class="input-group input-group-sm m-1">
      <span class="input-group-text form-text-sm" id="load-label">Load (t)</span>
      <input type="number" class="form-control number-input form-text-sm" id="load${vehicleNumber}-${num}" min="3.0" max="42.0" step="0.1" value=${load} aria-describedby="load-label" >
   </div>
   <div class="m-1" style="display: none;">
      <label id="max-label${vehicleNumber}-${num}" class="form-label max-load-info" >Max Load (t):
         &nbsp ${badgeHtml} &nbsp
      </label>
      ${iconHtml}
   </div>`;

   return html;
}

// function getMaxLoadTxt(groupElement) {
//    var maxLoadElement = $(groupElement).find('.max-load-value');
//    return maxLoadElement.text();
// }

//
// Handle loads and max loads
//

function updateDefaultLoads(vehicleNumber) {
   // Get the current form selections and determine max loads for each axle group.
   // Called when vehicle is selected initially and when user selects a new vehicle.
   // Then recalculate

   // UPdated now to handle the AMMS cases
   const vmanager = vehicleNumber == 1 ? v : v2;
   const selectedVehicle = vmanager.getActiveVehicle();
   const ammsLevel = getAMMSLevel(selectedVehicle);

   const selections = getAxleGroupSelections(vehicleNumber); // get axle config

   // query api to get the default loads for these axle group configurations
   let formData = {
      groups: selections, // []
      ammsLevel,
   };
   $.ajax({
      url: '/api/esa-loads',
      type: 'POST',
      data: formData,
      success: function (d) {
         if (!d.error) {
            updateVehicleLoads(vehicleNumber, d.data.maxLoads);
            updateDefaultMasses(vehicleNumber); // update tare and derive payload with gcm wit new loads
            CalculateVehicle(vehicleNumber); // if the loads change the results need to be updated again also.
         } else {
            console.error('Invalid loads received: ' + d.message);
         }
         // update results
      },
      error: function (jqXHR, textStatus, errorThrown) {
         console.error('Error response when getting loads');
      },
   });
}

function getAMMSLevel(selectedVehicle) {
   const levelMapping = {
      'level 1': 1,
      'level 2': 2,
      'level 3': 3,
   };
   const approvedLevel = selectedVehicle.approved.toLowerCase(); // 'Level 2' or "RAV" etc.
   return levelMapping[approvedLevel] || 0; // default is 0 if not found.
}

function updateDefaultMasses(vehicleNumber) {
   // When vehicle changes, get the default tare for the vehicle, and find payload, update both.
   const vmanager = vehicleNumber == 1 ? v : v2;
   const selectedVehicle = vmanager.getActiveVehicle();

   const tare = getDefaultVehicleTare(selectedVehicle);
   const gcm = getTotalLoad(vehicleNumber);
   const startPayload = gcm - tare;
   setGCM(vehicleNumber, gcm);
   setPayload(vehicleNumber, startPayload);
   updateTare(vehicleNumber, startPayload);
}

function updateVehicleLoads(vehicleNumber, d) {
   // max load is returned for each group when results received - update form to show max load

   // for each axle group in this vehicle
   d.forEach((item) => {
      const id = `max-label${vehicleNumber}-${item.groupNumber}`;
      const maxLoad = item.maxLoad;
      let maxLoadElement = $(`#${id}`).find('.max-load-value');
      maxLoadElement.text(maxLoad); // keep updated even though not displaying

      // load = maxload as default
      // Use the maxload value to reset the input load, but only when the vehicle hasn't been modified (after reset)
      const inputID = `load${vehicleNumber}-${item.groupNumber}`;
      let userChangedVehicle = vehicleIsChanged[vehicleNumber];
      if (!userChangedVehicle) {
         $(`#${inputID}`).val(maxLoad);
      }
      // update the icon status
      let maxLoadIcon = $(`#max-load-icon${vehicleNumber}-${item.groupNumber}`);
      //const inputLoadVal = parseFloat($(`#${inputID}`).val());

      // if (inputLoadVal > maxLoad + 0.01) {
      //    maxLoadIcon.show();
      // } else maxLoadIcon.hide();

      // don't show
      maxLoadIcon.hide();
      maxLoadElement.hide();
   });
}

//
// API Calculations
//

function calcEsa(vehicleNumber, selections) {
   // The AJAX results function - called at end of CalculateVehicle();
   let formData = {
      groups: selections, // []
   };
   $.ajax({
      url: '/api/esa-calc',
      type: 'POST',
      data: formData,
      success: function (d) {
         if (!d.error) {
            refreshResults(vehicleNumber, d.results); // populates results cards, table and loads (in not modified)
         } else {
            console.error('Invalid results received: ' + d.results);
         }
         // update results
      },
      error: function (jqXHR, textStatus, errorThrown) {
         console.error('Error response when calculating');
      },
   });
}

//
// Results Display
//

function refreshResults(vehicleNumber, data) {
   // Called after calculation completion, after each CalculateVehicle() request.
   populateResultsDetailTable(vehicleNumber, data);
   populateResultsCards(vehicleNumber, data);
}

function populateResultsCards(vehicleNumber, data) {
   const payload = getPayload(vehicleNumber);

   // add fade effect for results cards
   $('.esa-card').fadeOut(function () {
      // ESA
      $(`#totalESAValue-${vehicleNumber}`).text(data.totalEsa.toFixed(2));
      $(`#groupESAValue-${vehicleNumber}`).text(data.esaPerAxleGroup.toFixed(2));
      if (payload) $(`#payloadESAValue-${vehicleNumber}`).text((data.totalEsa / payload).toFixed(2));
      else $(`#payloadESAValue-${vehicleNumber}`).text('N/A');

      // SAR5
      $(`#totalSAR5Value-${vehicleNumber}`).text(data.totalSar5.toFixed(2));
      $(`#groupSAR5Value-${vehicleNumber}`).text(data.sar5PerAxleGroup.toFixed(2));
      if (payload) $(`#payloadSAR5Value-${vehicleNumber}`).text((data.totalSar5 / payload).toFixed(2));
      else $(`#payloadSAR5Value-${vehicleNumber}`).text('N/A');

      // SAR7
      $(`#totalSAR7Value-${vehicleNumber}`).text(data.totalSar7.toFixed(2));
      $(`#groupSAR7Value-${vehicleNumber}`).text(data.sar7PerAxleGroup.toFixed(2));
      if (payload) $(`#payloadSAR7Value-${vehicleNumber}`).text((data.totalSar7 / payload).toFixed(2));
      else $(`#payloadSAR7Value-${vehicleNumber}`).text('N/A');

      // SAR12
      $(`#totalSAR12Value-${vehicleNumber}`).text(data.totalSar12.toFixed(2));
      $(`#groupSAR12Value-${vehicleNumber}`).text(data.sar12PerAxleGroup.toFixed(2));
      if (payload) $(`#payloadSAR12Value-${vehicleNumber}`).text((data.totalSar12 / payload).toFixed(2));
      else $(`#payloadSAR12Value-${vehicleNumber}`).text('N/A');
      $('.esa-card').fadeIn();
   });
}

function populateResultsDetailTable(vehicleNumber, data) {
   // Empty the table first
   $(`#detailedGroupResultsBody-${vehicleNumber}`).empty();

   // Iterate over the esaResults array
   data.esaResults.forEach((item) => {
      //let loadCellClass = item.load > item.maxLoad ? 'highlight-text-red' : '';
      let loadCellClass = ''; // maxload no longer displayed
      // Create a new row for each item
      let row = `
       <tr>
         <td>${item.groupNumber}</td>
         <td>${item.code}</td>
         <td>${item.maxLoad}</td>
         <td class="${loadCellClass}">${item.load}</td>
         <td>${item.esa.toFixed(2)}</td>
         <td>${item.sar5.toFixed(2)}</td>
         <td>${item.sar7.toFixed(2)}</td>
         <td>${item.sar12.toFixed(2)}</td>
       </tr>
     `;
      $(`#detailedGroupResultsBody-${vehicleNumber}`).append(row);
   });

   // Add a totals row
   let totalsRow = `
   <tr class="total-row">
     <td title="Totals for the vehicle combination based on GCM">Total</td>
     <td></td>
     <td></td>
     <td>${data.totalLoad}</td>
     <td>${data.totalEsa.toFixed(2)}</td>
     <td>${data.totalSar5.toFixed(2)}</td>
     <td>${data.totalSar7.toFixed(2)}</td>
     <td>${data.totalSar12.toFixed(2)}</td>
   </tr>
 `;
   $(`#detailedGroupResultsBody-${vehicleNumber}`).append(totalsRow);

   let perGroupRow = `
 <tr class="per-group-row">
   <td>Per axle group</td>
   <td></td>
   <td></td>
   <td></td>
   <td>${data.esaPerAxleGroup.toFixed(2)}</td>
   <td>${data.sar5PerAxleGroup.toFixed(2)}</td>
   <td>${data.sar7PerAxleGroup.toFixed(2)}</td>
   <td>${data.sar12PerAxleGroup.toFixed(2)}</td>
 </tr>
`;
   $(`#detailedGroupResultsBody-${vehicleNumber}`).append(perGroupRow);

   const payload = getPayload(vehicleNumber);
   if (payload) {
      const esaPerPayload = (data.totalEsa / payload).toFixed(2);
      const sar5PerPayload = (data.totalSar5 / payload).toFixed(2);
      const sar7PerPayload = (data.totalSar7 / payload).toFixed(2);
      const sar12PerPayload = (data.totalSar12 / payload).toFixed(2);

      let perPayloadRow = `
    <tr class="per-group-row">
      <td>Per payload tonne</td>
      <td></td>
      <td></td>
      <td></td>
      <td>${esaPerPayload}</td>
      <td>${sar5PerPayload}</td>
      <td>${sar7PerPayload}</td>
      <td>${sar12PerPayload}</td>
    </tr>
   `;
      $(`#detailedGroupResultsBody-${vehicleNumber}`).append(perPayloadRow);
   }
}

//
//  Masses
//

// We now keep track of payload and tare on the form and GCM is sum of configured loads.
// update tare and payload if there is a change.

function setGCM(vehicleNumber, value) {
   const gcm = value.toFixed(1);
   $(`#info-gcm-${vehicleNumber}`).text(gcm); // update current gcm value
}

function getGCM(vehicleNumber) {
   const gcm = $('#info-gcm-' + vehicleNumber).text();
   if (gcm) {
      const val = parseFloat(gcm).toFixed(1);
      return val > 0.01 ? gcm : 0;
   } else return false; // when gcm not specified
}

function setPayload(vehicleNumber, value) {
   // if we set payload we need to also update the tare
   if (typeof value === 'number' && value >= 0 && value <= 200.0) {
      const newPayload = parseFloat(value).toFixed(1);
      $('#payload-' + vehicleNumber).val(newPayload);
   } else {
      console.error('Invalid payload value provided');
   }
}

function updateTare(vehicleNumber, payload) {
   // update tare based on payload
   const gcm = getGCM(vehicleNumber);
   const newTare = parseFloat(gcm - payload).toFixed(1);
   $('#tare-' + vehicleNumber).val(newTare);
}

function getPayload(vehicleNumber) {
   const payload = $('#payload-' + vehicleNumber).val();
   const val = parseFloat(payload).toFixed(1);
   return val;
}

function getTare(vehicleNumber) {
   const tare = $('#tare-' + vehicleNumber).val();
   return tare;
}

function getDefaultVehicleTare(selectedVehicle) {
   // Return the typical tare for this vehicle
   const tareTxt = selectedVehicle.tare;
   const tareVal = parseFloat(tareTxt.replace(/[^\d.-]/g, '')); // replace all non-numeric chars with '' and parse to float
   return tareVal;
}

function getActiveVehicleNumber() {
   // based on tab visible
   var id = $('.tab-content > .tab-pane.active').attr('id');
   let vehicleNumber = parseInt(id.split('-').pop());
   return vehicleNumber;
}

//
// Compare table
//

$('#compare-tab').click(function () {
   populateCompareTable();
   displayCompareImages();
});

function displayCompareImages() {
   const selectedVehicle1 = v.getActiveVehicle();
   const selectedVehicle2 = v2.getActiveVehicle();
   const path1 = v.getImagePath();
   const path2 = v2.getImagePath();
   // vehicle1-image
   $(`#vehicle1-image`).attr('src', path1 + selectedVehicle1.image);
   $(`#vehicle2-image`).attr('src', path2 + selectedVehicle2.image);
}

function populateCompareTable() {
   const data = {
      'c-desc-val-1-general': $(`#info-vehicle-1`).text(),
      'c-desc-val-2-general': $(`#info-vehicle-2`).text(),
      'c-length-val-1-general': $(`#info-network-1`).text() + ' / ' + $(`#info-length-1`).text(),
      'c-length-val-2-general': $(`#info-network-2`).text() + ' / ' + $(`#info-length-2`).text(),
      'c-axle-val-1-general': $(`#info-axles-1`).text(),
      'c-axle-val-2-general': $(`#info-axles-2`).text(),
      'c-payload-val-1-general': getPayload(1),
      'c-payload-val-2-general': getPayload(2),
      'c-tare-val-1-general': getGCM(1) + ' / ' + getTare(1),
      'c-tare-val-2-general': getGCM(2) + ' / ' + getTare(2),

      'c-esa-est-1': $(`#totalESAValue-1`).text(),
      'c-esa-est-2': $(`#totalESAValue-2`).text(),
      'c-esa-axle-1': $(`#groupESAValue-1`).text(),
      'c-esa-axle-2': $(`#groupESAValue-2`).text(),
      'c-esa-tonne-1': $(`#payloadESAValue-1`).text(),
      'c-esa-tonne-2': $(`#payloadESAValue-2`).text(),

      'c-sar5-est-1': $(`#totalSAR5Value-1`).text(),
      'c-sar5-est-2': $(`#totalSAR5Value-2`).text(),
      'c-sar5-axle-1': $(`#groupSAR5Value-1`).text(),
      'c-sar5-axle-2': $(`#groupSAR5Value-2`).text(),
      'c-sar5-tonne-1': $(`#payloadSAR5Value-1`).text(),
      'c-sar5-tonne-2': $(`#payloadSAR5Value-2`).text(),

      'c-sar7-est-1': $(`#totalSAR7Value-1`).text(),
      'c-sar7-est-2': $(`#totalSAR7Value-2`).text(),
      'c-sar7-axle-1': $(`#groupSAR7Value-1`).text(),
      'c-sar7-axle-2': $(`#groupSAR7Value-2`).text(),
      'c-sar7-tonne-1': $(`#payloadSAR7Value-1`).text(),
      'c-sar7-tonne-2': $(`#payloadSAR7Value-2`).text(),

      'c-sar12-est-1': $(`#totalSAR12Value-1`).text(),
      'c-sar12-est-2': $(`#totalSAR12Value-2`).text(),
      'c-sar12-axle-1': $(`#groupSAR12Value-1`).text(),
      'c-sar12-axle-2': $(`#groupSAR12Value-2`).text(),
      'c-sar12-tonne-1': $(`#payloadSAR12Value-1`).text(),
      'c-sar12-tonne-2': $(`#payloadSAR12Value-2`).text(),
   };

   $.each(data, function (id, value) {
      $('#' + id).text(value);
   });

   computeDiff('c-esa-est-1', 'c-esa-est-2', 'c-esa-est-diff');
   computeDiff('c-esa-axle-1', 'c-esa-axle-2', 'c-esa-axle-diff');
   computeDiff('c-esa-tonne-1', 'c-esa-tonne-2', 'c-esa-tonne-diff', true);

   computeDiff('c-sar5-est-1', 'c-sar5-est-2', 'c-sar5-est-diff');
   computeDiff('c-sar5-axle-1', 'c-sar5-axle-2', 'c-sar5-axle-diff');
   computeDiff('c-sar5-tonne-1', 'c-sar5-tonne-2', 'c-sar5-tonne-diff', true);

   computeDiff('c-sar7-est-1', 'c-sar7-est-2', 'c-sar7-est-diff');
   computeDiff('c-sar7-axle-1', 'c-sar7-axle-2', 'c-sar7-axle-diff');
   computeDiff('c-sar7-tonne-1', 'c-sar7-tonne-2', 'c-sar7-tonne-diff', true);

   computeDiff('c-sar12-est-1', 'c-sar12-est-2', 'c-sar12-est-diff');
   computeDiff('c-sar12-axle-1', 'c-sar12-axle-2', 'c-sar12-axle-diff');
   computeDiff('c-sar12-tonne-1', 'c-sar12-tonne-2', 'c-sar12-tonne-diff', true);
}

// Compute and set the differences
function computeDiff(id1, id2, diffId, percent = false) {
   const value1 = parseFloat($('#' + id1).text());
   const value2 = parseFloat($('#' + id2).text());

   if (!isNaN(value1) && !isNaN(value2)) {
      const diff = value2 - value1;
      const diffStr = diff > 0 ? '+' + diff.toFixed(2) : diff.toFixed(2);

      const diffPercent = diff / value1;
      const percentStr = ' (' + (diffPercent * 100).toFixed(1) + '%)';

      if (percent) $('#' + diffId).text(diffStr + percentStr);
      else $('#' + diffId).text(diffStr);

      if (diff > 0) {
         $('#' + diffId).css('color', 'red');
      } else if (diff < 0) {
         $('#' + diffId).css('color', 'green');
      }
   }
}

export function toPercentageOne(floatPercent) {
   const percent = floatPercent * 100;
   const roundedOne = Math.round(percent * 10) / 10;

   return roundedOne;
}
